import * as THREE from "three";
import { COMIC_FONT } from "./text-panel.ts";

// A white sign with a black border + black comic-style text (the meme bubble).
// Auto-shrinks the font so the text fits the plate width.
export function textPlate(
  text: string,
  planeWidth: number,
  planeHeight: number,
): THREE.Mesh {
  const canvas = document.createElement("canvas");
  canvas.width = 512;
  canvas.height = Math.max(64, Math.round(512 * (planeHeight / planeWidth)));
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("2d canvas context unavailable");

  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.strokeStyle = "#000000";
  ctx.lineWidth = 10;
  ctx.strokeRect(8, 8, canvas.width - 16, canvas.height - 16);

  const maxW = canvas.width - 44;
  let size = Math.round(canvas.height * 0.5);
  const font = (s: number) => `bold ${s}px ${COMIC_FONT}`;
  ctx.font = font(size);
  while (size > 12 && ctx.measureText(text).width > maxW) {
    size -= 2;
    ctx.font = font(size);
  }

  ctx.fillStyle = "#000000";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(text, canvas.width / 2, canvas.height / 2 + 2);

  const tex = new THREE.CanvasTexture(canvas);
  tex.colorSpace = THREE.SRGBColorSpace;
  const mat = new THREE.MeshBasicMaterial({ map: tex, transparent: true });
  const mesh = new THREE.Mesh(
    new THREE.PlaneGeometry(planeWidth, planeHeight),
    mat,
  );
  mesh.userData.skipEdges = true;
  return mesh;
}
